import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import renderInputForField from '../helpers/renderInputForField';
import { capitalizeFirst } from '../../utils/stringUtils';

class DomainField extends Component {
  render() {
    const {
      fieldName = 'domain',
      label = 'Domain URL',
      inputCaption,
      showRequired = true,
      showLabel = true,
    } = this.props;

    const displayLabel = showLabel ? label : '';

    return (
      <Field
        name={fieldName}
        component={renderInputForField}
        label={`${displayLabel}${showRequired ? '*' : ''}`}
        format={capitalizeFirst}
        inputCaption={inputCaption}
        stackedlabel
        {...{
          inputProps: {
            type: 'text',
          },
          itemProps: {},
        }}
      />
    );
  }
}

DomainField.propTypes = {
  fieldName: PropTypes.string,
  label: PropTypes.string,
  inputCaption: PropTypes.string,
  showRequired: PropTypes.bool,
};

export default DomainField;
